/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PipelineFilterSchemaMinDegree = typeof PipelineFilterSchemaMinDegree[keyof typeof PipelineFilterSchemaMinDegree] | null;


export const PipelineFilterSchemaMinDegree = {
  associates: 'associates',
  bachelors: 'bachelors',
  masters: 'masters',
  phd: 'phd',
} as const;
